import { useEffect, useState } from 'react';
import { useActiveUser } from 'shared/hooks/use-active-user';

// pipes
import { datePipe } from 'shared/pipes';
import { Ellipsis } from 'shared/pipes/ellipsis';

const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
}

const AuthorName = (comment) => {
    const currentUser = useActiveUser();
    const [userName, setUserName] = useState('Someone');

    const getUserName = async () => {
        if (!comment.author) {
            return null;
        }

        try {
            const author = await comment.author.get();

            if (author.id === currentUser.id) {
                setUserName('You');
                return;
            }

            const { first_name, last_name } = author.data();
            setUserName(`${first_name} ${last_name}`);
        } catch (error) {
            return null;
        }
    }

    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed) {
            getUserName();
        }
        return () => isSubscribed = false;
    });

    if (!comment) {
        return null;
    }
    return (
        <span>
            Added by <Ellipsis>{userName}</Ellipsis>
        </span>
    );
}

const Comment = ({ comment, className, onDelete, edit = false }) => {
    const DeleteButton = ({ edit }) => {
        if (!edit) {
            return null;
        }

        const handleClick = () => {
            if (!window.confirm('Are you sure?')) {
                return;
            };
            onDelete && onDelete(comment.id);
        }

        return (
            <small>
                <span className="icon-text is-clickable"
                    onClick={handleClick}
                >
                    <i className="fas fa-trash"></i>
                </span>
            </small>
        )
    }

    const date = datePipe.transform(comment.timestamp.seconds);

    return (
        <div className={`${className}`} style={{ transform: `rotate(${getRandomInt(-5, 6)}deg)` }}>
            <div className="card-content pt-0 mt-0">
                <div className="content">
                    <div className="columns my-0">
                        <div className="column is-auto">
                            {comment.content}
                        </div>

                        <div className="column is-1">
                            <DeleteButton edit={edit} />
                        </div>
                    </div>

                </div>
                <div className="columns">

                    <div className="column is-offset-6">
                        <small>
                            <time className="has-tooltip-arrow" data-tooltip={date}>
                                {date && date}
                            </time>

                            <div className="">
                                <AuthorName comment={comment} />
                            </div>
                        </small>
                    </div>
                </div >
            </div >
        </div >
    );
};

const CommentWrapper = ({ comment, index, onDelete, edit }) => {
    const background = ['has-background-info', 'has-background-link', 'has-background-warning'][index % 3];

    return (
        <Comment comment={comment} className={background} onDelete={onDelete} edit={edit} />
    )
}

export { CommentWrapper as Comment };
